<template>
    <img
        v-bind="forwardedAttrs"
        :src="logoSource"
        :alt="altText"
        :class="classes"
    >
</template>

<script setup>
import { computed } from 'vue';
import { useAttrs } from 'vue';
import { useStore } from 'vuex';
import { getLogo, getBrandName } from '@/assets/js/whiteLabel';

defineOptions({
    inheritAttrs: false
});

const props = defineProps({
    variant: {
        type: String,
        default: 'header'
    },
    alt: {
        type: String,
        default: ''
    }
});

const attrs = useAttrs();

const forwardedAttrs = computed(() => {
    const { class: classAttr, ...rest } = attrs;
    return rest;
});

const classes = computed(() => {
    const base = ['logo'];
    if (props.variant !== 'footer') base.push('py-20');
    const classAttr = attrs.class;
    if (!classAttr) return base;
    if (Array.isArray(classAttr)) {
        base.push(...classAttr);
        return base;
    }
    if (typeof classAttr === 'object') {
        Object.entries(classAttr).forEach(([key, value]) => {
            if (value) base.push(key);
        });
        return base;
    }
    base.push(classAttr);
    return base;
});

const store = useStore();
const theme = computed(() => store.state.user.theme);

const logoSource = computed(() => getLogo(props.variant, theme.value));

const altText = computed(() => {
    if (props.alt) return props.alt;
    return `${getBrandName()} logo`;
});
</script>

<style scoped>
img {
    max-width: 100%;
    max-height: 280px;
    object-fit: contain;
}
</style>

